import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import "chart.js/auto";
import dayjs from "dayjs";

import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

import moment from "moment";
import RangpoService from "../../services/rangpo.service";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

function TollCollection() {
  const [activeYearly, setActiveYearly] = useState(1);

  const [loading, setLoading] = useState(false);
  const [graphData, setGraphData] = useState([]);
  const [graphData2, setGraphData2] = useState([]);

  const gradient = document.createElement("canvas").getContext("2d");
  const gradientFill = gradient.createLinearGradient(0, 0, 0, 250);
  const gradientFill2 = gradient.createLinearGradient(0, 0, 0, 250);

  gradientFill.addColorStop(0, "rgba(200, 181, 237, 1)"); // Start color
  gradientFill.addColorStop(1, "rgba(255, 255, 255, 1)"); // End color

  gradientFill2.addColorStop(0, "rgba(193, 255, 230, 1)"); // Start color
  gradientFill2.addColorStop(1, "rgba(255, 255, 255, 1)"); // End color

  const formatter = new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: 2,
  });

  const handleYearlyFilter = (from) => {
    setActiveYearly(from);
  };

  useEffect(() => {
    fetchCash();
    fetchInvoice();
  }, [activeYearly]);

  const fetchCash = () => {
    setLoading(true);
    const req = {
      type: activeYearly.toString(),
      category: "1",
    };

    RangpoService.getRangpoTollCollection(req)
      .then((response) => {
        // setLoading(false);
        setGraphData(response.data);
      })
      .catch((e) => console.log(e));
  };

  const fetchInvoice = () => {
    setLoading(true);
    const req = {
      type: activeYearly.toString(),
      category: "2",
    };

    RangpoService.getRangpoTollCollection(req)
      .then((response) => {
        setLoading(false);
        setGraphData2(response.data);
      })
      .catch((e) => console.log(e));
  };

  const generateLast7DaysData = () => {
    if (graphData.length != 0) {
      const data = graphData.map((item) =>
        moment(item.month_Year, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YY")
      );
      return data;
    } else {
      return;
    }
  };

  const generateLast7YearsData = () => {
    if (graphData.length != 0) {
      const data = graphData.map((itm) => itm.month_Year);
      return data;
    } else {
      return;
    }
  };

  const months = Array.from({ length: dayjs().month() + 1 }, (_, i) =>
    dayjs().month(i).format("MMM")
  );

  const data =
    activeYearly === 1
      ? generateLast7DaysData()
      : activeYearly === 2
      ? months
      : activeYearly === 3
      ? generateLast7YearsData()
      : [];

  const rangpoFooter = (tooltipItems) => {
    let sum = {};
    let sum2 = {};

    if (activeYearly === 1) {
      tooltipItems.forEach(function (tooltipItem) {
        sum = graphData.filter(
          (itm) =>
            moment(itm.month_Year, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YY") ===
            tooltipItem.label
        );
        sum2 = graphData2.filter(
          (itm) =>
            moment(itm.month_Year, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YY") ===
            tooltipItem.label
        );
      });
    } else {
      tooltipItems.forEach(function (tooltipItem) {
        sum = graphData.filter((itm) => itm.month_Year === tooltipItem.label);
        sum2 = graphData2.filter((itm) => itm.month_Year === tooltipItem.label);
      });
    }

    if (sum.length != 0) {
      let sum1 = tooltipItems.reduce((summ, item) => {
        return summ + item.parsed.y || 0;
      }, 0);

      return `Total Amt: ₹${formatter.format(
        sum1
      )}\n\nCounter Toll:\nAmount Collected: ₹${formatter.format(
        sum[0].totalCount
      )}\nReceipt Count: ${
        sum[0].receiptCount
      }\n\nOnline Toll:\nAmount Collected: ₹${formatter.format(
        sum2[0].totalCount
      )}\nReceipt Count: ${sum2[0].receiptCount}`;
    }
  };

  const rangpoDataset = [
    {
      label: "Online Toll",
      data:
        graphData2.length != 0
          ? graphData2.map((item) => item.totalCount)
          : null,
      borderColor: "rgb(19, 196, 125)",
      backgroundColor: gradientFill2,
      tension: 0.5,
      fill: true,
      borderWidth: 0.5,
    },
    {
      label: `Counter Toll`,
      data:
        graphData.length != 0 ? graphData.map((item) => item.totalCount) : null,
      borderColor: "rgba(172, 145, 228, 1)",
      backgroundColor: gradientFill,
      tension: 0.5,
      fill: true,
      borderWidth: 0.5,
    },
  ];

  const chartData = {
    labels: data,
    datasets: rangpoDataset,
  };

  const options = {
    responsive: true,
    offset: true,
    stacked: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "nearest",
      axis: "x",
      intersect: false,
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        border: {
          display: false,
        },
        ticks: {
          font: {
            size: 13,
            weight: "bold",
            family: "Jost",
          },
        },
      },
      y: {
        display: true,
        grid: {
          display: true,
        },
        border: {
          display: false,
        },
        title: {
          display: true,
          text: "Amount (in ₹)",
        },
      },
    },
    plugins: {
      legend: {
        display: true,
        onClick: null,
        position: "top",
        align: "end",
        labels: {
          boxWidth: 13,
          useBorderRadius: true,
          borderRadius: "6px",
        },
      },
      tooltip: {
        displayColors: true,
        yAlign: "bottom",
        backgroundColor: "rgba(254, 235, 230, 1)",
        titleColor: "black",
        bodyColor: "black",
        footerColor: "black",
        callbacks: {
          label: function (context) {
            return null;
          },
          beforeBody: rangpoFooter,
        },
        bodyFont: {
          size: 17,
          family: "Jost, sans-serif",
        },
        titleFont: {
          size: 16,
          family: "Jost, sans-serif",
        },

        // usePointStyle: true,
      },
      datalabels: {
        display: false,
      },
    },
  };

  return (
    <>
      <div className="graph-header">
        <div className="graph-heading">Toll Collection</div>
        <div className="graph-yearly-filter">
          <div
            className={activeYearly === 1 ? "filter-box active" : "filter-box"}
            onClick={() => handleYearlyFilter(1)}
          >
            Last 7 Days
          </div>
          <div
            className={activeYearly === 2 ? "filter-box active" : "filter-box"}
            onClick={() => handleYearlyFilter(2)}
          >
            Monthly
          </div>
          <div
            className={activeYearly === 3 ? "filter-box active" : "filter-box"}
            onClick={() => handleYearlyFilter(3)}
          >
            Yearly
          </div>
        </div>
      </div>

      <div className="">
        {loading ? (
          <>
            <div className="loading-area">
              <div
                class="spinner-border "
                style={{ color: "rgb(247, 177, 140)" }}
                role="status"
              >
                <span class="sr-only"></span>
              </div>
              <span>Data is Loading...</span>
            </div>
          </>
        ) : (
          <>
            <Line data={chartData} options={options} width={600} height={275} />
          </>
        )}
      </div>
    </>
  );
}

export default TollCollection;
